import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Check, Loader2 } from "lucide-react";

export default function ConfirmWisdom() {
  const [params] = useSearchParams();
  const [state, setState] = useState("loading"); // loading | ok | error
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = params.get("token") || "";
    if (!token) { setState("error"); setMsg("This confirmation link is invalid."); return; }
    api.post("/send-wisdom/confirm", { token })
      .then((r) => { setState("ok"); setMsg(r.data.message || "You're confirmed."); })
      .catch((e) => { setState("error"); setMsg(e.response?.data?.detail || "This link is invalid or has expired."); });
  }, [params]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5 py-16 bg-[#FDFBF7]">
      <div data-testid="confirm-wisdom-card" className="max-w-md w-full text-center rounded-3xl border border-[#E2E8F0] bg-white px-8 py-12">
        <div className="mx-auto mb-6 grid place-items-center w-14 h-14 rounded-full bg-[#F1F5F1]">
          {state === "loading" ? <Loader2 className="w-7 h-7 text-[#2C4C3B] animate-spin" /> : <Check className="w-7 h-7 text-[#2C4C3B]" />}
        </div>
        <h1 className="font-serif-display text-3xl text-[#0F172A]">{state === "ok" ? "You're confirmed." : state === "error" ? "Hmm." : "One moment…"}</h1>
        <p className="text-[#475569] mt-3 leading-relaxed">{msg}</p>
        <Link to="/" className="inline-block mt-8 px-6 py-3 rounded-full bg-[#2C4C3B] text-white font-medium">Go to I Need a Proverb</Link>
      </div>
    </div>
  );
}
